/** Настройки внешнего вида — только в браузере (на устройство/монитор). */

export const LOCAL_UI_SETTING_KEYS = [
    'theme',
    'message_font_size',
    'chat_list_font_size',
    'button_scale',
    'image_preview_size',
];

const STORAGE_KEY = 'bananasgpt_ui_settings';

const DEFAULTS = {
    theme: 'system',
    message_font_size: 15,
    chat_list_font_size: 14,
    button_scale: 1,
    image_preview_size: 480,
};

function clamp(n, lo, hi, fallback) {
    const v = Number(n);
    if (!Number.isFinite(v)) return fallback;
    return Math.min(hi, Math.max(lo, v));
}

export function normalizeLocalUi(raw = {}) {
    return {
        theme: ['system', 'light', 'dark'].includes(raw.theme) ? raw.theme : DEFAULTS.theme,
        message_font_size: clamp(raw.message_font_size, 12, 24, DEFAULTS.message_font_size),
        chat_list_font_size: clamp(raw.chat_list_font_size, 11, 20, DEFAULTS.chat_list_font_size),
        button_scale: clamp(raw.button_scale, 0.75, 1.5, DEFAULTS.button_scale),
        image_preview_size: clamp(raw.image_preview_size, 200, 960, DEFAULTS.image_preview_size),
    };
}

export function readLocalUiSettings() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        return normalizeLocalUi(parsed);
    } catch (_) {
        return null;
    }
}

export function writeLocalUiSettings(patch = {}) {
    const prev = readLocalUiSettings() || { ...DEFAULTS };
    const next = normalizeLocalUi({ ...prev, ...patch });
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (_) {
        /* ignore quota / private mode */
    }
    return next;
}

/** Один раз перенести UI-настройки с сервера в localStorage, если локальных ещё нет */
export function migrateUiSettingsFromServer(serverSettings) {
    if (readLocalUiSettings()) return readLocalUiSettings();
    if (!serverSettings || typeof serverSettings !== 'object') {
        return writeLocalUiSettings({ ...DEFAULTS });
    }
    const fromServer = {};
    for (const key of LOCAL_UI_SETTING_KEYS) {
        if (serverSettings[key] != null) fromServer[key] = serverSettings[key];
    }
    return writeLocalUiSettings(fromServer);
}

export function splitSettingsPatch(patch = {}) {
    const localPatch = {};
    const remotePatch = {};
    for (const [key, value] of Object.entries(patch || {})) {
        if (LOCAL_UI_SETTING_KEYS.includes(key)) localPatch[key] = value;
        else remotePatch[key] = value;
    }
    return { localPatch, remotePatch };
}

export function stripLocalUiFromServerSettings(data = {}) {
    const out = { ...data };
    for (const key of LOCAL_UI_SETTING_KEYS) {
        delete out[key];
    }
    return out;
}
